import { inject, Service } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { LocationComposite } from '@lib.core/entities/location/location-composite.entity';
import { Cachier } from '@lib.core/store/cachier';
import { LocationCompositeResource } from '@lib.resources/location/location-composite.resource';
import { LocationCompositeApiService } from '@lib.resources/location/location-composite-api.service';

@Service()
export class LocationCompositeStore implements LocationCompositeResource {

  private readonly cache = inject(Cachier);
  private readonly apiService: LocationCompositeResource = inject(LocationCompositeApiService);
  private readonly baseKey = 'locationComposite';
  private readonly keys = new Set<string>();

  getLocationComposite(locationId: string, clientId: string): Observable<LocationComposite> {
    const key = `${this.baseKey}-getLocationComposite-${locationId}-${clientId}`;
    this.keys.add(key);
    return this.cache.get<LocationComposite>(key, () => this.apiService.getLocationComposite(locationId, clientId))
      .pipe(filter((entity: LocationComposite | null | undefined) => entity != null));
  }

  destroyAll() {
    this.keys.forEach((key: string) => this.cache.purge(key));
    this.keys.clear();
  }
}
